import imagesLoaded from 'imagesloaded'

export default () => ({
    categories: {
        ALL: 'ALL',
        CGI: 'CGI'
    },
    activeCategory: null,
    numberOfRows: 0,
    positionFromTop: 300,
    leftColumnVerticalAlignmentClass: 'justify-center',
    rightColumnVerticalAlignmentClass: 'justify-center',
    imageLeftSrc: '',
    imageRightSrc: '',
    timeoutId: null,
    speed: 400,
    imagesNotLoaded: true,
    positions: {
        TOP: 'justify-start',
        CENTER: 'justify-center',
        BOTTOM: 'justify-end',
        TOP_END: 'justify-start items-end',
        BOTTOM_END: 'justify-end items-end',
    },

    isTouchDevice() {
        let mql = window.matchMedia('(max-width: 1279px)');
        return mql.matches;
    },

    async waitFor(timeout = 1000) {
        return new Promise((resolve, reject) => {

            setTimeout(() => {

                resolve('Success');
            }, timeout);

        });
    },
    async hideAll() {
        const elements = this.$refs.list.querySelectorAll('li')
        elements.forEach(element => {
            element.classList.add('hidden')
        });

    },
    async hideCategory(cat) {
        //
        const elements = this.$refs.list.querySelectorAll('li')
        elements.forEach(element => {
            const category = element.dataset.projectCategory;
            if (category.toUpperCase() === cat || !category) {
                element.classList.add('hidden')
            }
        });
    },
    async showCategory(cat) {
        const elements = this.$refs.list.querySelectorAll('li')
        elements.forEach(element => {
            const category = element.dataset.projectCategory;
            if (category.toUpperCase() === cat) {
                element.classList.remove('hidden')
            }
        });

    },
    async init() {

        this.activeCategory = this.categories.CGI


        // console.log('%c%s', 'color: #00a3cc', 'work list');
        this.$el.classList.remove('hidden')


        await this.waitFor(500)

        if(!this.isTouchDevice()){
        await this.setImageSizesAndPaths();
        await this.loadAllImages();
        }

        this.setContainerSize();
        //const firstProject = this.$refs.items.querySelector('li')
        //this.setAlignmentClasses(firstProject);
        this.$refs.imageLeft.style.opacity = 0;
        this.$refs.imageRight.style.opacity = 0;
        this.imagesNotLoaded = false;
        this.hideAll();
        this.showCategory(this.activeCategory);
    },
    showTab(selectedCategory) {
        // console.log('click')
        const CATEGORY = selectedCategory.toUpperCase();
        this.activeCategory = this.categories[CATEGORY]
        this.hideAll();
        this.showCategory(this.activeCategory)
    },
    onMouseLeave() {
        if (this.isTouchDevice()) return;
        // console.log('%c%s', 'color: #ffa280', 'on mouse eave');
        this.$refs.imageLeft.style.opacity = 0;
        this.$refs.imageRight.style.opacity = 0;
    },
    async setImageSizesAndPaths() {
        if (!this.$refs.list) return;
        const elements = this.$refs.list.querySelectorAll('li')


        elements.forEach(li => {
            let leftWidth = 1200
            let leftHeight = 1200
            let rightWidth = 400
            let rightHeight = 400

            let leftImageHeight = 100;
            let leftImageWidth = 100;

            let rightImageHeight = 100;
            let rightImageWidth = 100;
            if (li.dataset.orientationLeft === "landscape") {

                leftImageWidth = this.$refs.leftColumn.offsetWidth;
                leftImageHeight = (leftImageWidth / 3) * 3;
                leftWidth = leftImageWidth;
                leftHeight = leftImageHeight;

            } else if (li.dataset.orientationLeft === "portrait") {

                leftImageHeight = this.$refs.leftColumn.offsetHeight / 2;
                leftImageWidth = (leftImageHeight / 3) * 3;
                leftWidth = leftImageWidth;
                leftHeight = leftImageHeight;
            }

            // Right column
            this.rightColumnVerticalAlignmentClass = this.positions[li.dataset.alignmentRight.toUpperCase()]
            if (li.dataset.orientationRight === "square") {
                rightImageWidth = this.$refs.rightColumn.offsetWidth;
                rightImageHeight = rightImageWidth;
                rightWidth = rightImageWidth;
                rightHeight = rightImageHeight;
            } else if (li.dataset.orientationRight === "landscape") {
                rightImageWidth = this.$refs.rightColumn.offsetWidth;
                rightImageHeight = (rightImageWidth / 3) * 3;
                rightWidth = rightImageWidth;
                rightHeight = rightImageHeight;
            }


            // const left = `https://thirdaesthetic.imgix.net/${li.dataset.imageLeft}?w=${leftWidth}&h=${leftHeight}&fit=crop&auto=compress,format`
            // const right = `https://thirdaesthetic.imgix.net/${li.dataset.imageRight}?w=${rightWidth}&h=${rightHeight}&fit=crop&auto=compress,format`

            const left = `https://thirdaesthetic.imgix.net/${li.dataset.imageLeft}?w=${800}&h=${800}&fit=crop&auto=compress,format`
            const right = `https://thirdaesthetic.imgix.net/${li.dataset.imageRight}?w=${800}&h=${800}&fit=crop&auto=compress,format`

            var imgLeft = document.createElement('img');
            imgLeft.src = left;
            var imgRight = document.createElement('img');
            imgRight.src = right;


            console.log('appending')
            this.$refs.images.appendChild(imgLeft)
            this.$refs.images.appendChild(imgRight)

            li.dataset.imagePathLeft = left;
            li.dataset.imagePathRight = right;

            // images
            // console.log('%c%s', 'color: #733d00', 'image');
            // console.log(left,right)
            // Set images
            // https://www.dropbox.com/sh/u4udxwlrn3jnfvj/AABoaT1LNI-uoEoKtgHat4vxa?dl=0
            // ta77.imgix.net
            // https://pix2.imgix.net/plenti.jpg?w=1920&h=1280&fit=crop&crop=focalpoint&auto=compress&fm=webp&fp-x=0.5&fp-y=0.5&fp-z=1
            //https://www.dropbox.com/s/qnik9c6b6oqa6er/airbnb_001.jpeg?dl=0


            // this.imageLeftSrc = `https://thirdaesthetic.imgix.net/${li.dataset.imageLeft}?w=${leftWidth}&h=${leftHeight}&fit=crop&auto=compress&fm=webp`
            // this.imageRightSrc = `https://thirdaesthetic.imgix.net/${li.dataset.imageRight}?w=${rightWidth}&h=${rightHeight}&fit=crop&auto=compress&fm=webp`

        });
        // console.log(elements)
    },

    async loadAllImages() {
        return new Promise((resolve, reject) => {

            // console.time('images')
            const imgLoad = imagesLoaded(this.$refs.images);

            imgLoad.on('progress', function (instance, image) {
                var result = image.isLoaded ? 'loaded' : 'broken';
                //console.log('image is ' + result + ' for ' + image.img.src);
            });
            imgLoad.on('always', function () {

                resolve('Success');
                //console.log('alawys')

            });
        });
    },

    async setAlignmentClasses(li = null) {
        window.clearTimeout(this.timeoutId);


        this.$refs.imageLeft.style.opacity = 0;
        this.$refs.imageRight.style.opacity = 0;

        this.timeoutId = setTimeout(() => {

            let leftWidth = 1200
            let leftHeight = 1200
            let rightWidth = 400
            let rightHeight = 400

            let leftImageHeight = 100;
            let leftImageWidth = 100;

            let rightImageHeight = 100;
            let rightImageWidth = 100;

            if (li === null) {
                this.leftColumnVerticalAlignmentClass = this.positions.CENTER;
                this.rightColumnVerticalAlignmentClass = this.positions.TOP;
                return;
            }

            // Left Column
            if (li.dataset.orientationLeft === "landscape") {


                this.leftColumnVerticalAlignmentClass = this.positions[li.dataset.alignmentLeftLandscape.toUpperCase()]
            } else if (li.dataset.orientationLeft === "portrait") {


                switch (li.dataset.alignmentLeftPortrait) {
                case 'top':
                    this.leftColumnVerticalAlignmentClass = this.positions.TOP_END;
                    break;
                case 'bottom':
                    this.leftColumnVerticalAlignmentClass = this.positions.BOTTOM_END;
                    break;
                default:
                    break;
                }

            }

            // Right column
            this.rightColumnVerticalAlignmentClass = this.positions[li.dataset.alignmentRight.toUpperCase()]


            // Set images
            // https://www.dropbox.com/sh/u4udxwlrn3jnfvj/AABoaT1LNI-uoEoKtgHat4vxa?dl=0
            // ta77.imgix.net
            // https://pix2.imgix.net/plenti.jpg?w=1920&h=1280&fit=crop&crop=focalpoint&auto=compress&fm=webp&fp-x=0.5&fp-y=0.5&fp-z=1
            //https://www.dropbox.com/s/qnik9c6b6oqa6er/airbnb_001.jpeg?dl=0


            this.imageLeftSrc = li.dataset.imagePathLeft
            this.imageRightSrc = li.dataset.imagePathRight

            this.$refs.imageLeft.style.opacity = 1;
            this.$refs.imageRight.style.opacity = 1;

        }, this.speed);

    },


    onMouseEnter() {
        if (this.isTouchDevice()) return;
        this.setAlignmentClasses(this.$el)

    },
    onWindowResize() {

        this.setContainerSize();

    },

    setContainerSize() {

        // console.log('%c%s', 'color: #807160', 'setContainerSize');
        const worklistwrapper = document.body.querySelector('#worklistwrapper');

        this.$refs.wrapper1.style.height = `${worklistwrapper.clientHeight - 60}px`
        this.$refs.wrapper2.style.height = `${worklistwrapper.clientHeight - 60}px`
        // this.$refs.wrapper1.style.height = `${window.innerHeight - 170}px`
        // this.$refs.wrapper2.style.height = `${window.innerHeight - 170}px`

        this.$refs.wrapper1.style.top = 0// `${this.positionFromTop - 100}px`;
        this.$refs.wrapper2.style.top = 0// `${this.positionFromTop - 100}px`;
        // this.$el.style.maxHeight = `${window.innerHeight - this.positionFromTop}px`
        // this.$el.style.top = `${this.positionFromTop / 2}px`;

        // const myHeight = window.innerHeight - this.positionFromTop;
        //console.log(myHeight)
        // //this.$refs.column.style.height = `${myHeight/6}px`
        // this.$refs.leftColumn.style.height = `${myHeight}px`
        // this.$refs.rightColumn.style.height = `${myHeight}px`

        // this.$refs.leftColumnImage.style.maxHeight = `${myHeight / this.numberOfRows}px`

    },

    setNumberOfRows() {
        this.numberOfRows = 3;
    }


})
